import { Button, IconButton, Link, useMediaQuery, useTheme } from "@mui/material";

import { useTranslate } from "src/locales";
import { useLazyGetKnowledgeBaseLinkQuery } from 'src/services/system/system.service';

import Iconify from "src/components/iconify";
import { RouterLink } from "src/routes/components";

export const KnowledgeBaseButton = () => {

  const { t } = useTranslate();

  const theme = useTheme();

  const isNotLargeDevice = useMediaQuery(theme.breakpoints.down('md'));

  const [getKnowledgeBaseLink] = useLazyGetKnowledgeBaseLinkQuery();

  if (isNotLargeDevice) {
    return (
      <Link component={RouterLink} href="mailto:support@jobtetris.com" underline="none">
        <IconButton
          color="primary"
        >
          <Iconify icon="solar:documents-line-duotone" />
        </IconButton>
      </Link>
    );
  }

  return (
    <Link component={RouterLink} href="mailto:support@jobtetris.com" underline="none">
      <Button
        variant="outlined"
        color="primary"
        startIcon={<Iconify icon="solar:documents-line-duotone" />}
      >
        {t('common.help')}
      </Button>
    </Link>
  );
}